import React, { useState } from 'react';

// ── Petit cours avant l'exercice ────────────────────────────────────────────
// Règle posée par le propriétaire (2026-07-25) : « les exos complètement
// nouveaux pour moi doivent quand même avoir des explications et un petit cours
// avant, sinon je suis dans le noir ».
//
// Un exercice d'examen sans mode d'emploi ne mesure pas le niveau, il mesure la
// familiarité avec la consigne. Sur le subtest d'écriture c'est pire : on ne
// devine pas les formules d'une lettre officielle russe, on les apprend.
//
// Comportement : ouvert par défaut, refermé dès qu'on l'a lu une fois (mémorisé
// par clé dans localStorage), et TOUJOURS rouvrable. On ne cache jamais le cours
// définitivement : le jour où l'on rate un exercice, c'est là qu'on veut le
// relire.

const key = (id) => `motrusse_lecon_${id}`;

export default function Lecon({ id, titre, children }) {
  const [ouvert, setOuvert] = useState(() => {
    try { return localStorage.getItem(key(id)) !== 'lu'; } catch { return true; }
  });

  const basculer = () => {
    setOuvert((o) => {
      const next = !o;
      // On ne marque « lu » qu'à la FERMETURE : ouvrir puis quitter la page ne
      // doit pas compter comme lu.
      try { if (!next) localStorage.setItem(key(id), 'lu'); } catch {}
      return next;
    });
  };

  return (
    <section className="bg-slate-800/60 border border-slate-700 rounded-xl overflow-hidden">
      <button
        onClick={basculer}
        className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-slate-700/40 transition-colors"
      >
        <svg
          viewBox="0 0 20 20"
          className={`w-3 h-3 fill-slate-500 shrink-0 transition-transform ${ouvert ? 'rotate-90' : ''}`}
          aria-hidden="true"
        >
          <path d="M6 4l8 6-8 6V4z" />
        </svg>
        <span className="text-sm font-semibold text-slate-200">{titre}</span>
        <span className="ml-auto text-[11px] text-slate-500 shrink-0">
          {ouvert ? 'masquer' : 'lire'}
        </span>
      </button>
      {ouvert && (
        <div className="px-4 pb-4 pt-1 text-sm text-slate-300 leading-relaxed flex flex-col gap-3 border-t border-slate-700/60">
          {children}
        </div>
      )}
    </section>
  );
}

// Ligne d'un mini-tableau de cours : un terme russe, sa valeur, un exemple.
export const Regle = ({ terme, quand, exemple }) => (
  <div className="grid grid-cols-[5.5rem_1fr] gap-x-3 gap-y-0.5">
    <div className="text-blue-300 font-medium">{terme}</div>
    <div className="text-slate-300">
      {quand}
      {exemple && <div className="text-slate-500 text-[13px] mt-0.5">{exemple}</div>}
    </div>
  </div>
);
